import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';
import {
  BuyerQualificationsResponseDto,
  DecipherMappingsResponseDto,
  PutDecipherMappingsPayloadDto,
} from './dtos/decipher-mapping.dto';
import { DecipherMappingMapper } from './mappers/decipher-mapping.mapper';
import { DecipherQualificationMapper } from './mappers/decipher-qualification.mapper';
import {
  BuyerQualification,
  LocaleQuestionMappings,
} from '../state/decipher/decipher-mapping-state.model';
import { withLoading } from '@ps/core-loading';

@Injectable({ providedIn: 'root' })
export class DecipherMappingApi {
  private readonly _http = inject(HttpClient);
  private readonly _envConfig = inject(ENV_CONFIG);
  private readonly _mappingMapper = new DecipherMappingMapper();
  private readonly _qualificationMapper = new DecipherQualificationMapper();

  private readonly _baseUrl = this._envConfig.pureSpectrum.decipherUrl;

  public mappings(cmp: number): Observable<LocaleQuestionMappings[]> {
    return this._http
      .get<DecipherMappingsResponseDto>(
        `${this._baseUrl}/v2/companies/${cmp}/mappings/locale/all`,
        { context: withLoading('page') },
      )
      .pipe(
        map((response) => this._mappingMapper.fromDtoList(response.mappings)),
      );
  }

  public qualifications(
    cmp: number,
    locale: string,
  ): Observable<BuyerQualification[]> {
    return this._http
      .get<BuyerQualificationsResponseDto>(
        `${this._baseUrl}/v2/companies/${cmp}/qualifications`,
        {
          context: withLoading('page'),
          params: new HttpParams().set('locale', locale),
        },
      )
      .pipe(
        map((response) => this._qualificationMapper.fromDtoList(response.data)),
      );
  }

  public saveMappings(
    cmp: number,
    locale: string,
    payload: PutDecipherMappingsPayloadDto,
  ): Observable<void> {
    return this._http.put<void>(
      `${this._baseUrl}/v2/companies/${cmp}/mappings/locale/${locale}`,
      payload,
    );
  }
}
